import { createFileRoute } from "@tanstack/react-router";
import { AppLayout } from "@/components/layouts/AppLayout";
import { AdminCommunitiesPage } from "@/components/pages/AdminCommunitiesPage";

export const Route = createFileRoute("/admin/communities")({
  component: AdminCommunities,
});

function AdminCommunities() {
  return (
    <AppLayout>
      <AdminCommunitiesPage />
    </AppLayout>
  );
}
